export default __webpack_public_path__ + "static/media/logo-black.978a3041.png";